import request from '@/utils/request'

// export function fetchUserId(query) {
//   return request({
//     baseURL: 'https://sb-focus.mosoga.net/',
//     url: 'user/byUserId',
//     method: 'get',
//     params: query
//   })

export const appId=10204;
/** 小绿帽服务器域名 **/
const testGreenBaseUrl = "https://sb-greenhat.mosoga.net/";
const releaseGreenBaseUrl = "https://gh10204.mosoga.net/";

/** 账号服服务器域名 **/
const testFocusBaseUrl = "https://sb-focus.mosoga.net/";
const releaseFocusBaseUrl = "https://focus.mosoga.net/";

/** 调用的域名 **/
const greenBaseUrl = releaseGreenBaseUrl;
export const focusBaseUrl = releaseFocusBaseUrl;

export const isTest=false;

export function fetchUserId(query) {
    return request({
        baseURL: greenBaseUrl,
        url: 'greenhatapi/index/roleList',
        method: 'get',
        params: query
    });
}

export function userCommodity(query) {
  return request({
    baseURL: greenBaseUrl,
    url: 'greenhatapi/index/chargeInfo',
    method: 'get',
    params: query
  });
}

export function createAlipayOrder(query) {
    return request({
        baseURL: focusBaseUrl,
        url: 'official/create/alipayorder',
        method: 'post',
        data: query
    });
}

export function createWXOrder(query) {
  return request({
      baseURL: focusBaseUrl,
      url: 'official/create/wxpayorder',
      method: 'post',
      data: query
  });
}

